import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewIndex = () => import('./index')

Vue.use(Router)

const router =
  [
    {
      path: '/sa/settings',
      component: DefaultContainer,
      children: [
        {
          path: 'configurate',
          name: 'SA_SettingsConfigurate',
          component: ViewIndex,
          beforeEnter: Permisos.IS_SUPERADMIN,
          meta: {
            title: 'Permisos',
          }                    
        },
      ]
    },
  ]

export default router
